import * as React from "react";

import { cn } from "@/lib/utils";

export interface EmptyStateProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
  /** Serene glyph, inside the porcelain circle. */
  icon?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  /** Action area — the primary CTA, or redirect chips. */
  children?: React.ReactNode;
}

/** TB brand Empty State — redirects instead of frustrating. No red: empty is not an error. */
export const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ className, icon, title, description, children, ...props }, ref) => (
    <div
      ref={ref}
      className={cn("mx-auto max-w-[380px] px-7 py-12 text-center", className)}
      {...props}
    >
      {icon != null && (
        <span className="mb-5 inline-grid h-14 w-14 place-content-center rounded-full bg-[var(--tb-porcelain-tint)] text-tb-green [&_svg]:h-[26px] [&_svg]:w-[26px]">
          {icon}
        </span>
      )}
      <h3 className="mb-2 font-display text-[22px] font-normal text-[var(--fg)]">
        {title}
      </h3>
      {description != null && (
        <p className="mb-[22px] text-sm leading-relaxed text-[var(--fg-muted)]">
          {description}
        </p>
      )}
      {children}
    </div>
  ),
);
EmptyState.displayName = "EmptyState";
